var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row voffset3"},[_c('h4',{staticClass:"text-center",domProps:{"textContent":_vm._s(_vm.progressBarLabel)}}),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('progressBar',{attrs:{"now":_vm.currentCompletion,"type":"success","striped":"","label":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }